import { render, staticRenderFns } from "./readlateremaildetails.vue?vue&type=template&id=195609b2&"
import script from "./readlateremaildetails.vue?vue&type=script&lang=js&"
export * from "./readlateremaildetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports